import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './ag-theme-ela.css';

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc',
  },
};

const interpreterColumns = [
  {
    headerName: 'Interpreter Name',
    field: 'intLastName',
    cellRenderer: 'intNameCellRenderer',
    width: 125,
  },
  { headerName: 'Fax', field: 'intFax', width: 150 },
  { headerName: 'Cell/Text', field: 'intCellTxt', width: 100 },
  { headerName: 'Phone Only', field: 'intPhoneOnly', width: 100 },
  { headerName: 'City', field: 'intCity', width: 100 },
  { headerName: 'State', field: 'intState', width: 100 },
  { headerName: 'Zip', field: 'intZip', width: 75 },
  { headerName: 'Gender', field: 'intGender', width: 60 },
  { headerName: 'Notes', field: 'intNote', width: 350 },
];

export class InterpreterTableDefault extends Component {
  constructor(props) {
    super(props);
    this.gridApi = null;
    this.gridColumnApi = null;

    this.onGridReady = this.onGridReady.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.autoSizeUnspecifiedColumns =
      this.autoSizeUnspecifiedColumns.bind(this);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns();
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text'
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });
      maxHeight += 10;
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  autoSizeUnspecifiedColumns = () => {
    if (!this.gridColumnApi) return;
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: interpreterColumns,
      rowData: this.props.interpreters,
      context: {
        componentParent: this,
        gridApi: this.gridApi,
        setModal: this.setModal,
        state: this.state,
      },
      animateRows: true,
      defaultColDef: defaultColDef,
      frameworkComponents: {
        // Register the cell renderer
        intNameCellRenderer: IntNameCellRenderer,
      },
      onColumnResized: this.onColumnResized,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      onRowDoubleClicked: this.props.handleDoubleClick,
      onRowClicked: this.props.handleClick,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '400px',
        }}
      >
        <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
      </div>
    );
  }
}

class IntNameCellRenderer extends Component {
  render() {
    const { data } = this.props; // ag-Grid passes the data prop automatically to the renderer
    const name = `${data.intLastName}, ${data.intFirstName}`; 

    if(data.unavailableReason !== null)
    {
      return (
        <span
          style={{
            color: 'red'
          }}
        >
          {name}
        </span>
      );
    } else {
      return (
        <span
          style={{
            color: 'black'
          }}
        >
          {name}
        </span>
      );
    }

    return <span>{name}</span>;
  }
}
